import { CustomButton } from 'modules/auth/styles'
import { getCategories_action, getContents_action, getPrivateAndFavoriteContents_action, toggleMoveToCategoryModal_action } from 'store/actions'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Modal, ModalBody } from 'reactstrap'
import { ButtonLoader, PageLoader } from 'utils/storageUtils'
import { allCategoryIds, generateBreadcrumb, getTitle, handleApiError, logAmplitudeEvent } from 'utils/helpers'
import { toast } from 'react-toastify'
import { colors, ImportTabsContent, ModalForm } from 'modules/app/styles'
import { CategoriesSelector } from 'modules/pages/components/CategoriesSelector'
import { checkShortcut_api, drageAndDropPublishedContent_api, getContentByUUID_api } from 'store/apis'

function MoveToCategoryModal(props) {
  const { user, pages, responses, movingContent } = props
  const [isSubmitting, set_isSubmitting] = useState(false)
  const [showLoader, set_showLoader] = useState(false)
  const [content, setContent] = useState({})
  const [selectedCategory, setSelectedCategory] = useState({})
  const [private_categories, set_private_categories] = useState([])
  const [shared_categories, set_shared_categories] = useState([])
  const [preExpandedCategory, set_preExpandedCategory] = useState([])
  const [showCategoriesAccordion, set_showCategoriesAccordion] = useState(false)

  useEffect(() => {
    const getContent = async (uuid) => {
      try {
        set_showLoader(true)
        const data = await getContentByUUID_api(uuid)
        if (data.id) {
          setContent({ ...data, category: data.category || {} })
          setSelectedCategory(data.category || {})

          const _preExpandedCategory = []
          if (data.category_id) {
            const _breadbrumb = generateBreadcrumb(data.category, [], data)
            for (const b of _breadbrumb) {
              _preExpandedCategory.push(`cat_${b.id}`)
            }
          }
          set_preExpandedCategory(_preExpandedCategory)
          setTimeout(() => {
            set_showCategoriesAccordion(true)
          }, 100)
        }
      } catch (error) {
        handleApiError(error)
      }
      set_showLoader(false)
    }
    if (movingContent.uuid) {
      getContent(movingContent.uuid)
    }
  }, [movingContent])

  const onMoveClick = async () => {
    try {
      set_isSubmitting(true)

      if (content.shortcut) {
        const all_private_categories_ids = allCategoryIds(private_categories)
        const all_shared_categories_ids = allCategoryIds(shared_categories)
        let checkForDuplicateShortcut = false
        const filters = { shortcut: encodeURIComponent(content.shortcut), content_uuid: content.uuid }
        // PRIVATE TO SHARED
        if (all_shared_categories_ids.includes(selectedCategory.id) && (!content.category_id || all_private_categories_ids.includes(content.category_id))) {
          checkForDuplicateShortcut = true
        }
        // SHARED TO PRIVATE
        else if (all_shared_categories_ids.includes(content.category_id) && (!selectedCategory.id || all_private_categories_ids.includes(selectedCategory.id))) {
          checkForDuplicateShortcut = true
          filters.check_for = 'private'
        }
        if (checkForDuplicateShortcut) {
          const res = await checkShortcut_api(filters)
          if (res?.id) {
            toast.error(
              <>
                <p className='text-danger mb-1'>Unable to move the response.</p>
                The response shortcut <span className='font-weight-600'>{content.shortcut}</span> is already taken by somebody
              </>
            )
            set_isSubmitting(false)
            return
          }
        }
      }

      await drageAndDropPublishedContent_api({ category_id: selectedCategory.id }, content.uuid)
      if (content.category?.uuid) {
        await props.getContents({ category_uuid: content.category.uuid, type: content.type })
      } else {
        await props.getPrivateAndFavoriteContents({ type: content.type })
      }
      if (selectedCategory?.id) {
        await props.getContents({ category_uuid: selectedCategory?.uuid, type: content.type })
      } else {
        await props.getPrivateAndFavoriteContents({ type: content.type })
      }
      toast.success(`${content.type} moved successfully!`)
      logAmplitudeEvent('Web: Moved to category')
      props.toggleMoveToCategoryModal(false)
    } catch (error) {
      handleApiError(error)
    }
    set_isSubmitting(false)
  }

  useEffect(() => {
    if (content.id) {
      if (content.type === 'page') {
        set_shared_categories(pages.shared_categories)
        set_private_categories(content.user_id === user.id ? pages.private_categories : [])
      } else if (content.type === 'response') {
        set_shared_categories(responses.shared_categories)
        set_private_categories(content.user_id === user.id ? responses.private_categories : [])
      }
    }
  }, [user.id, content, pages, responses])

  const selectCategory = (category) => {
    if (selectedCategory.id === category.id) {
      setSelectedCategory({})
    } else {
      setSelectedCategory(category)
    }
  }
  return (
    <Modal zIndex={props.fullScreenStatus ? '300000000000' : ''} centered fade={false} size='sm' isOpen={true} toggle={() => props.toggleMoveToCategoryModal(false)}>
      <ModalBody className='pt-5 pb-4'>
        <ModalForm tag='div'>
          <div className='title d-flex'>Move to category</div>
          <br />
          <ImportTabsContent>
            {[...private_categories, ...shared_categories].length === 0 && (
              <div className='text-center' style={{ background: colors['light-blue-100'] }}>
                {showLoader ? <PageLoader /> : `No page category found.`}
              </div>
            )}
            {showCategoriesAccordion && [...private_categories, ...shared_categories].length > 0 && (
              <CategoriesSelector
                user={user}
                selectCategory={(cat) => selectCategory(cat)}
                preExpandedCategory={preExpandedCategory}
                category={selectedCategory}
                private_categories={private_categories}
                shared_categories={shared_categories}
                type={content.type}
                getCategories={props.getCategories}
              />
            )}
          </ImportTabsContent>
          <br />

          <div>
            Move <span className='font-weight-600'>{getTitle(content.title)}</span> to: <span className='font-weight-600'>{selectedCategory.name}</span>
          </div>
          <div className='mt-4 d-flex justify-content-center align-items-center'>
            <CustomButton className='black mx-4' disabled={isSubmitting} onClick={onMoveClick}>
              Move
              {isSubmitting && <ButtonLoader />}
            </CustomButton>
            <a
              href='/'
              className='mx-3 text-dark'
              onClick={(e) => {
                e.preventDefault()
                props.toggleMoveToCategoryModal(false)
              }}>
              Cancel
            </a>
          </div>
        </ModalForm>
      </ModalBody>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  responses: state.contents.responses,
  pages: state.contents.pages,
  movingContent: state.contents.movingContent,
  fullScreenStatus: state.contents.isFullScreen
})

const mapDispatchToProps = (dispatch) => ({
  getContents: (filters) => new Promise((resolve, reject) => dispatch(getContents_action(filters, resolve, reject))),
  getPrivateAndFavoriteContents: (filters) => new Promise((resolve, reject) => dispatch(getPrivateAndFavoriteContents_action(filters, resolve, reject))),
  getCategories: () => dispatch(getCategories_action()),
  toggleMoveToCategoryModal: (showMoveToCategoryModal) => dispatch(toggleMoveToCategoryModal_action(showMoveToCategoryModal))
})
export default connect(mapStateToProps, mapDispatchToProps)(MoveToCategoryModal)
